module.exports = __webpack_public_path__ + "app/principal/widgets/msg-file-upload/msg-file-upload-AtwOdfbr.html";